export default __webpack_public_path__ + "cf9517b91bcb059789256df72d3ad48e.png";